import { useEffect, useRef, useState } from 'react';

const REDUCED_MOTION_TOTAL_MS = 300;

function prefersReducedMotion() {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
}

/**
 * Reveals `stepCount` loading lines over `totalMs`, then calls `onDone` once the data it was
 * waiting for (`isReady`) has also arrived.
 */
export function useTimedSequence(
  stepCount: number,
  totalMs: number,
  isReady: boolean,
  onDone: () => void,
) {
  const [completed, setCompleted] = useState(0);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    const stepMs = (prefersReducedMotion() ? REDUCED_MOTION_TOTAL_MS : totalMs) / stepCount;
    const timer = window.setInterval(
      () => setCompleted(count => Math.min(stepCount, count + 1)),
      stepMs,
    );
    return () => window.clearInterval(timer);
  }, [stepCount, totalMs]);

  const isFinished = completed >= stepCount && isReady;

  useEffect(() => {
    if (isFinished) onDoneRef.current();
  }, [isFinished]);

  return { completed, progress: (completed / stepCount) * 100 };
}
